

// import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
// import { useSearchParams, useNavigate, Link, useLocation } from "react-router-dom";
// import {
//   Package,
//   Home,
//   ChevronRight,
//   Filter,
//   X,
//   ChevronDown,
// } from "lucide-react";
// import FilterPanel from "../components/FiltersPanel";
// import ProductCard, { ProductCardSkeleton } from "../components/NewProductCard";
// import Pagination from "../components/Pagination";
// import { fetchProducts, fetchFilterOptions } from "../services/api";
// import useDebounce from "../hooks/useDebounce";
// import { API_CONFIG, SORT_OPTIONS, debugLog } from "../constants/config";

// // Constants
// const RESERVED_PARAMS = ["taxonomy", "term", "termName", "label", "page", "sort", "order"];
// const DEFAULT_TAXONOMY = "equipment-buy";
// const PINNED_LIMIT = 3;

// // Utility functions
// const parseFiltersFromParams = (params) => {
//   const filters = {};
//   params.forEach((value, key) => {
//     if (!RESERVED_PARAMS.includes(key) && value) {
//       filters[key] = value.includes(",") 
//         ? value.split(",").map(v => v.trim()).filter(Boolean)
//         : value;
//     }
//   });
//   return filters;
// };

// const createFilterHash = (filters) => {
//   if (!filters || typeof filters !== 'object') return '';
//   const sorted = Object.keys(filters).sort();
//   return sorted.map(key => {
//     const val = filters[key];
//     return `${key}:${Array.isArray(val) ? val.join(',') : val}`;
//   }).join('|');
// };

// // ✅ NEW: Create category identifier to detect navigation changes
// const createCategoryIdentifier = (searchParams) => {
//   const taxonomy = searchParams.get("taxonomy") || DEFAULT_TAXONOMY;
//   const term = searchParams.get("term") || "";
//   const termName = searchParams.get("termName") || "";
//   const label = searchParams.get("label") || "";
  
//   return `${taxonomy}|${term}|${termName}|${label}`;
// };

// const sortProductsWithPinnedItems = (products, { category, tag, limit = PINNED_LIMIT }) => {
//   const pinned = [];
//   const regular = [];

//   for (const product of products) {
//     if (pinned.length >= limit) {
//       regular.push(product);
//       continue;
//     }

//     const productCategory =
//       product.attributes?.pa_category ||
//       product.pa_category ||
//       product.category ||
//       "";
//     const productTags = Array.isArray(product.tags)
//       ? product.tags.map((t) => (typeof t === "object" ? t.slug || t.name : t))
//       : [];

//     const matchesCategory =
//       productCategory?.toString().toLowerCase() === category.toLowerCase();
//     const matchesTag =
//       productTags.includes(tag) || productTags.includes(tag.toLowerCase());

//     if (matchesCategory && matchesTag) {
//       pinned.push(product);
//     } else {
//       regular.push(product);
//     }
//   }

//   return [...pinned, ...regular];
// };

// export default function ProductListingPage() {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const location = useLocation(); // ✅ Track location changes
  
//   // ✅ NEW: Track current category to detect changes
//   const currentCategoryRef = useRef(null);
//   const abortControllersRef = useRef({
//     products: null,
//     filters: null,
//     pinned: null,
//   });

//   // ✅ Derive initial state from URL
//   const initialState = useMemo(() => {
//     const taxonomy = searchParams.get("taxonomy") || DEFAULT_TAXONOMY;
//     const urlTerm = searchParams.get("term");
//     const parsedFilters = urlTerm 
//       ? { product_cat: [urlTerm] } 
//       : parseFiltersFromParams(searchParams);
//     const page = Math.max(1, parseInt(searchParams.get("page")) || 1);
//     const sort = {
//       orderby: searchParams.get("sort") || "rand",
//       order: searchParams.get("order") || "desc"
//     };

//     // ✅ Set initial category identifier
//     const categoryId = createCategoryIdentifier(searchParams);
//     currentCategoryRef.current = categoryId;

//     return { taxonomy, filters: parsedFilters, page, sort };
//   }, []);

//   // State
//   const [selectedTaxonomy, setSelectedTaxonomy] = useState(initialState.taxonomy);
//   const [filters, setFilters] = useState(initialState.filters);
//   const [page, setPage] = useState(initialState.page);
//   const [sort, setSort] = useState(initialState.sort);
//   const [viewMode, setViewMode] = useState("grid");
//   const [showMobileFilters, setShowMobileFilters] = useState(false);

//   // Data state
//   const [products, setProducts] = useState([]);
//   const [totalProducts, setTotalProducts] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const [filterOptions, setFilterOptions] = useState(null);
//   const [pinnedProducts, setPinnedProducts] = useState([]);
//   const [pinnedProductIds, setPinnedProductIds] = useState([]);

//   // Loading & error state
//   const [productsLoading, setProductsLoading] = useState(false);
//   const [filtersLoading, setFiltersLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // Debounced search
//   const searchValue = filters.search || "";
//   const debouncedSearch = useDebounce(
//     searchValue.length >= 3 ? searchValue : "",
//     500
//   );

//   // Memoized values
//   const activeFilterCount = useMemo(() => {
//     return Object.entries(filters).reduce((count, [key, value]) => {
//       if (key === "search") return count;
//       if (value === undefined || value === "" || value === null) return count;
//       if (Array.isArray(value) && value.length === 0) return count;
//       return count + 1;
//     }, 0);
//   }, [filters]);

//   const breadcrumb = useMemo(() => {
//     const parts = [
//       { label: <Home className="w-4 h-4" />, path: "/" },
//       { label: "Inventory", path: "/products" },
//     ];

//     const label = selectedTaxonomy === "equipment-buy" 
//       ? "For Sale" 
//       : "For Rent";
    
//     parts.push({
//       label,
//       path: `/products?taxonomy=${selectedTaxonomy}`,
//     });

//     return parts;
//   }, [selectedTaxonomy]);

//   const taxonomyOptions = useMemo(() => [
//     { value: "equipment-buy", label: "Buy" },
//     { value: "equipment-rent", label: "Rent" },
//   ], []);

//   const filterHash = useMemo(() => createFilterHash(filters), [filters]);

//   // Handle mobile filter visibility
//   useEffect(() => {
//     document.body.style.overflow = showMobileFilters ? "hidden" : "unset";

//     if (!showMobileFilters) return;

//     const handleEscape = (e) => {
//       if (e.key === "Escape") setShowMobileFilters(false);
//     };

//     window.addEventListener("keydown", handleEscape);

//     return () => {
//       window.removeEventListener("keydown", handleEscape);
//       document.body.style.overflow = "unset";
//     };
//   }, [showMobileFilters]);

//   // ✅ CRITICAL FIX: Detect category change and reset filters
//   useEffect(() => {
//     const newCategoryId = createCategoryIdentifier(searchParams);
//     const previousCategoryId = currentCategoryRef.current;

//     // ✅ If category/term changed, reset everything
//     if (previousCategoryId && previousCategoryId !== newCategoryId) {
//       debugLog("🔄 Category changed! Resetting filters...", {
//         previous: previousCategoryId,
//         new: newCategoryId
//       });

//       const taxonomy = searchParams.get("taxonomy") || DEFAULT_TAXONOMY;
//       const urlTerm = searchParams.get("term");
      
//       // ✅ Reset to clean state with only the base category filter
//       const freshFilters = urlTerm ? { product_cat: [urlTerm] } : {};
      
//       setFilters(freshFilters);
//       setSelectedTaxonomy(taxonomy);
//       setPage(1);
//       setError(null);
//       setProducts([]);
//       setPinnedProducts([]);
      
//       // Update ref
//       currentCategoryRef.current = newCategoryId;
      
//       return; // Exit early - don't sync other params
//     }

//     // ✅ Update ref if this is the first time
//     if (!previousCategoryId) {
//       currentCategoryRef.current = newCategoryId;
//     }

//     // ✅ Normal URL sync (only when category hasn't changed)
//     const taxonomy = searchParams.get("taxonomy") || DEFAULT_TAXONOMY;
//     const pageFromUrl = Math.max(1, parseInt(searchParams.get("page")) || 1);
//     const sortFromUrl = searchParams.get("sort") || "rand";
//     const orderFromUrl = searchParams.get("order") || "desc";

//     // Parse filters from URL
//     const newFilters = parseFiltersFromParams(searchParams);
//     const urlTerm = searchParams.get("term") || "";
    
//     // Ensure URL term is in filters
//     if (urlTerm) {
//       if (!newFilters.product_cat) {
//         newFilters.product_cat = [urlTerm];
//       } else if (!Array.isArray(newFilters.product_cat)) {
//         newFilters.product_cat = [newFilters.product_cat];
//       } else if (!newFilters.product_cat.includes(urlTerm)) {
//         newFilters.product_cat = [...newFilters.product_cat, urlTerm];
//       }
//     }

//     // Batch state updates
//     const currentFilterHash = createFilterHash(filters);
//     const newFilterHash = createFilterHash(newFilters);

//     if (selectedTaxonomy !== taxonomy) setSelectedTaxonomy(taxonomy);
//     if (currentFilterHash !== newFilterHash) setFilters(newFilters);
//     if (sort.orderby !== sortFromUrl || sort.order !== orderFromUrl) {
//       setSort({ orderby: sortFromUrl, order: orderFromUrl });
//     }
//     if (page !== pageFromUrl) setPage(pageFromUrl);
//     if (error) setError(null);

//   }, [location.pathname, searchParams.toString()]); // ✅ Added location.pathname

//   // Taxonomy change handler
//   const handleTaxonomyChange = useCallback((newTaxonomy) => {
//     setSelectedTaxonomy(newTaxonomy);
//     setFilters({});
//     setShowMobileFilters(false);
//     setPage(1);

//     const params = new URLSearchParams();
//     params.set("taxonomy", newTaxonomy);
//     setSearchParams(params);
//   }, [setSearchParams]);

//   // Filter change handler
//   const handleFilterChange = useCallback((newFilters) => {
//     setFilters(newFilters);

//     const params = new URLSearchParams();
//     params.set("taxonomy", selectedTaxonomy);
    
//     // Preserve category context
//     const term = searchParams.get("term");
//     const termName = searchParams.get("termName");
//     const label = searchParams.get("label");
    
//     if (term) params.set("term", term);
//     if (termName) params.set("termName", termName);
//     if (label) params.set("label", label);
    
//     // Add filter params
//     Object.entries(newFilters).forEach(([key, value]) => {
//       if (value !== null && value !== undefined && value !== "") {
//         if (Array.isArray(value) && value.length > 0) {
//           params.set(key, value.join(","));
//         } else if (!Array.isArray(value)) {
//           params.set(key, String(value));
//         }
//       }
//     });

//     // Reset to page 1
//     setPage(1);

//     setSearchParams(params, { replace: true });
//     setShowMobileFilters(false);
//   }, [selectedTaxonomy, searchParams, setSearchParams]);

//   // Sort change handler
//   const handleSortChange = useCallback((value) => {
//     const [orderby, order = "desc"] = value.split("-");
//     setSort({ orderby, order });

//     const params = new URLSearchParams(searchParams);
//     params.set("sort", orderby);
//     params.set("order", order);

//     setSearchParams(params);
//   }, [searchParams, setSearchParams]);

//   // Page change handler
//   const handlePageChange = useCallback((newPage) => {
//     setPage(newPage);

//     const params = new URLSearchParams(searchParams);
//     if (newPage > 1) {
//       params.set("page", newPage.toString());
//     } else {
//       params.delete("page");
//     }

//     setSearchParams(params);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, [searchParams, setSearchParams]);

//   // Load filter options
//   useEffect(() => {
//     const controller = new AbortController();
//     abortControllersRef.current.filters = controller;

//     const loadOptions = async () => {
//       setFiltersLoading(true);

//       try {
//         const response = await fetchFilterOptions(selectedTaxonomy, {
//           signal: controller.signal
//         });
//         if (!controller.signal.aborted) {
//           setFilterOptions(response);
//         }
//       } catch (err) {
//         if (err.name !== 'AbortError' && !controller.signal.aborted) {
//           setError("Failed loading filters: " + err.message);
//           debugLog("❌ Filter options error:", err);
//         }
//       } finally {
//         if (!controller.signal.aborted) {
//           setFiltersLoading(false);
//         }
//       }
//     };

//     loadOptions();

//     return () => {
//       controller.abort();
//       abortControllersRef.current.filters = null;
//     };
//   }, [selectedTaxonomy, filterHash, debouncedSearch]);

//   // Load pinned products
//   useEffect(() => {
//     if (page !== 1) {
//       setPinnedProducts([]);
//       return;
//     }

//     const controller = new AbortController();
//     abortControllersRef.current.pinned = controller;

//     const loadPinnedProducts = async () => {
//       try {
//         const res = await fetch(
//           "https://goldensparrowuae.com/wordpress/wp-json/custom/v1/products?pa_bestselling=yes&per_page=20",
//           { signal: controller.signal }
//         );
        
//         if (!res.ok) throw new Error('Failed to fetch pinned products');
        
//         const data = await res.json();
//         if (!data?.products || controller.signal.aborted) return;

//         const selectedTermName = searchParams.get("termName") || "";
        
//         const parentTermMap = {
//           "Diesel Forklifts": "Forklifts",
//           "Electric Forklifts": "Forklifts",
//         };

//         const effectiveTerm = parentTermMap[selectedTermName] || selectedTermName;

//         const filteredPinned = data.products.filter((product) => {
//           const categories = product.attributes?.pa_categories || [];
//           return categories.some(
//             (cat) => cat.toLowerCase().trim() === effectiveTerm.toLowerCase().trim()
//           );
//         });

//         if (!controller.signal.aborted) {
//           setPinnedProducts(filteredPinned);
//         }
//       } catch (err) {
//         if (err.name !== 'AbortError') {
//           console.error("❌ Failed to load pinned products:", err);
//           setPinnedProducts([]);
//         }
//       }
//     };

//     loadPinnedProducts();

//     return () => {
//       controller.abort();
//       abortControllersRef.current.pinned = null;
//     };
//   }, [searchParams.toString(), page]);




//   // Load products
//   useEffect(() => {
//     if (abortControllersRef.current.products) {
//       abortControllersRef.current.products.abort();
//     }

//     const controller = new AbortController();
//     abortControllersRef.current.products = controller;

//     const loadProducts = async () => {
//       setProductsLoading(true);
//       setError(null);

//       try {
//         const urlTerm = searchParams.get("term") || "";
//         const termName = searchParams.get("termName") || "";

//         const apiFilters = { ...filters };
//         const hasFilterCategory = apiFilters.product_cat?.length > 0;

//         if (hasFilterCategory) {
//           delete apiFilters.pa_categories;
//         } else if (urlTerm) {
//           apiFilters.pa_categories = urlTerm;
//         }

//         if (debouncedSearch) {
//           apiFilters.search = debouncedSearch;
//         } else {
//           delete apiFilters.search;
//         }

//         const baseParams = {
//           taxonomy: selectedTaxonomy,
//           page,
//           per_page: API_CONFIG.DEFAULT_PER_PAGE,
//           orderby: sort.orderby,
//           order: sort.order,
//           ...apiFilters,
//         };

//         delete baseParams.term;

//         const firstResponse = await fetchProducts(baseParams, {
//           signal: controller.signal
//         });
        
//         if (controller.signal.aborted) return;

//         let sortedProducts = firstResponse.products || [];

//         const shouldPin = termName.toLowerCase() === "forklifts";
//         let forkliftPinnedIds = [];

//         if (shouldPin && page === 1) {
//           sortedProducts = sortProductsWithPinnedItems(sortedProducts, {
//             category: "Forklifts",
//             tag: "Best Selling",
//             limit: PINNED_LIMIT,
//           });

//           forkliftPinnedIds = sortedProducts.slice(0, PINNED_LIMIT).map((p) => p.id);
//         }

//         const collected = [...sortedProducts];
//         const totalPagesFromApi = firstResponse.totalPages ?? 1;

//         if (collected.length < API_CONFIG.DEFAULT_PER_PAGE && page < totalPagesFromApi) {
//           let nextPage = page + 1;
//           let attempts = 0;

//           while (
//             collected.length < API_CONFIG.DEFAULT_PER_PAGE &&
//             nextPage <= totalPagesFromApi &&
//             attempts < 5 &&
//             !controller.signal.aborted
//           ) {
//             const topUpParams = { ...baseParams, page: nextPage };
//             const res = await fetchProducts(topUpParams, {
//               signal: controller.signal
//             });
            
//             if (controller.signal.aborted) return;

//             const nextProds = res.products || [];

//             for (const p of nextProds) {
//               if (!collected.find((c) => c.id === p.id)) {
//                 collected.push(p);
//               }
//             }

//             nextPage++;
//             attempts++;
//           }
//         }

//         if (!controller.signal.aborted) {
//           setProducts(collected);
//           setPinnedProductIds(forkliftPinnedIds);

//           const visibleTotal = firstResponse.total || collected.length;
//           setTotalProducts(visibleTotal);
//           setTotalPages(Math.max(1, Math.ceil(visibleTotal / API_CONFIG.DEFAULT_PER_PAGE)));
//         }

//       } catch (err) {
//         if (err.name !== 'AbortError' && !controller.signal.aborted) {
//           debugLog("❌ Failed loading products:", err);
//           setError(`Failed loading products: ${err.message}`);
//           setProducts([]);
//         }
//       } finally {
//         if (!controller.signal.aborted) {
//           setProductsLoading(false);
//         }
//       }
//     };

//     loadProducts();

//     return () => {
//       controller.abort();
//       abortControllersRef.current.products = null;
//     };
//   }, [
//     selectedTaxonomy,
//     page,
//     sort.orderby,
//     sort.order,
//     debouncedSearch,
//     filterHash,
//     searchParams.get("term"),
//     searchParams.get("termName"),
//   ]);

//   // Cleanup on unmount
//   useEffect(() => {
//     return () => {
//       Object.values(abortControllersRef.current).forEach(controller => {
//         if (controller) controller.abort();
//       });
//     };
//   }, []);

//   const termName = searchParams.get("termName") || "";
//   const label = searchParams.get("label") || "";

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* REST OF YOUR JSX - Keep the same render logic */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
//         {/* Breadcrumb */}
//         <nav
//           className="flex items-center text-sm text-gray-600 mb-6"
//           aria-label="Breadcrumb"
//         >
//           {breadcrumb.map((item, index) => (
//             <React.Fragment key={index}>
//               {index > 0 && <ChevronRight className="w-4 h-4 mx-2" aria-hidden="true" />}
//               {item.path ? (
//                 <Link 
//                   to={item.path} 
//                   className="hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black rounded"
//                 >
//                   {item.label}
//                 </Link>
//               ) : (
//                 <span className="text-gray-900 font-medium">{item.label}</span>
//               )}
//             </React.Fragment>
//           ))}
//         </nav>

//         {/* Page Header */}
//         <div className="mb-8">
//           <div className="bg-white rounded-lg shadow-md p-3 sm:p-4 mt-4">
//             <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4">
//               <div className="flex flex-row items-center gap-16">
//                 <h1 className="text-xl sm:text-3xl font-medium text-gray-900 mb-2">
//                   {termName ||
//                     label ||
//                     (selectedTaxonomy === "equipment-buy" ? "For Sale" : "For Rent")}
//                 </h1>
                
//                 <div className="flex items-center" role="status" aria-live="polite">
//                   <span className="text-[#5B5B5B]">
//                     {productsLoading ? (
//                       <span className="flex items-center gap-2">
//                         <div 
//                           className="w-5 h-5 border-3 border-gray-300 border-t-[#F7971E] rounded-full animate-spin"
//                           role="progressbar"
//                           aria-label="Loading products"
//                         />
//                         <span className="text-gray-700 font-medium">
//                           Loading products...
//                         </span>
//                       </span>
//                     ) : (
//                       <span>
//                         <span className="font-semibold text-[#5B5B5B]">
//                           {totalProducts}
//                         </span>{" "}
//                         products found
//                       </span>
//                     )}
//                   </span>
//                 </div>
//               </div>

//               <div className="flex items-center gap-3">
//                 <button
//                   onClick={() => setShowMobileFilters(true)}
//                   className="lg:hidden flex items-center gap-2 px-3 sm:px-4 py-2 bg-gradient-to-br from-[#FFD200] to-[#F7971E] text-white rounded-md hover:from-[#F7971E] hover:to-[#FFD200] transition-colors relative focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F7971E]"
//                   aria-label={`Open filters${activeFilterCount > 0 ? `, ${activeFilterCount} active` : ''}`}
//                 >
//                   <Filter className="w-4 h-4" aria-hidden="true" />
//                   <span className="text-xs sm:text-sm font-medium">Filters</span>
//                   {activeFilterCount > 0 && (
//                     <span 
//                       className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center"
//                       aria-label={`${activeFilterCount} filters active`}
//                     >
//                       {activeFilterCount > 9 ? "9+" : activeFilterCount}
//                     </span>
//                   )}
//                 </button>

//                 <div className="flex items-center gap-2">
//                   <label 
//                     htmlFor="sort-select" 
//                     className="text-sm text-gray-600 hidden sm:inline"
//                   >
//                     Sort by:
//                   </label>
//                   <div className="relative">
//                     <select
//                       id="sort-select"
//                       value={`${sort.orderby}-${sort.order}`}
//                       onChange={(e) => handleSortChange(e.target.value)}
//                       className="appearance-none pr-10 px-6 text-xs sm:text-base py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
//                       aria-label="Sort products by"
//                     >
//                       {SORT_OPTIONS.map((option) => (
//                         <option key={option.value} value={option.value}>
//                           {option.label}
//                         </option>
//                       ))}
//                     </select>
//                     <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-black">
//                       <ChevronDown className="w-4 h-4 sm:w-5 sm:h-5" aria-hidden="true" />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {error && (
//           <div
//             className="mb-6 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg"
//             role="alert"
//             aria-live="assertive"
//           >
//             <strong className="font-semibold">Error: </strong>
//             <span>{error}</span>
//           </div>
//         )}

//         {showMobileFilters && (
//           <div 
//             className="fixed inset-0 z-50 lg:hidden"
//             role="dialog"
//             aria-modal="true"
//             aria-labelledby="mobile-filters-title"
//           >
//             <div
//               className="absolute inset-0 bg-black bg-opacity-50 transition-opacity duration-300 ease-in-out"
//               onClick={() => setShowMobileFilters(false)}
//               aria-label="Close filters"
//             />

//             <div className="absolute inset-y-0 left-0 w-full max-w-sm bg-white shadow-xl overflow-y-auto transform transition-transform duration-300 ease-in-out translate-x-0">
//               <div className="p-4">
//                 <div className="flex items-center justify-between mb-4">
//                   <h2 id="mobile-filters-title" className="text-lg font-semibold">
//                     Filter Products
//                   </h2>
//                   <button
//                     onClick={() => setShowMobileFilters(false)}
//                     className="text-gray-900 font-semibold text-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black rounded p-1"
//                     aria-label="Close filters"
//                   >
//                     <X className="w-5 h-5" />
//                   </button>
//                 </div>

//                 <div className="bg-gray-50 rounded-lg p-3 mb-4">
//                   <p className="font-semibold text-sm my-2 text-gray-700">
//                     View Products For
//                   </p>
//                   <div className="flex flex-row gap-2">
//                     {taxonomyOptions.map((option) => (
//                       <button
//                         key={option.value}
//                         onClick={() => handleTaxonomyChange(option.value)}
//                         className={`w-full px-4 py-3 rounded-lg font-medium transition-all duration-200 flex items-center justify-center gap-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F7971E] ${
//                           selectedTaxonomy === option.value
//                             ? "bg-gradient-to-br from-[#FFD200] to-[#F7971E] text-black shadow-md"
//                             : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
//                         }`}
//                         aria-pressed={selectedTaxonomy === option.value}
//                       >
//                         <span className="text-sm font-semibold">{option.label}</span>
//                       </button>
//                     ))}
//                   </div>
//                 </div>

//                 <FilterPanel
//                   filters={filters}
//                   setFilters={handleFilterChange}
//                   filterOptions={filterOptions}
//                   isLoading={filtersLoading}
//                 />
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
//           <aside className="hidden lg:block lg:col-span-1" aria-label="Product filters">
//             <div className="sticky top-20">
//               <div className="bg-white rounded-lg shadow-md p-4 mb-4">
//                 <div className="flex gap-2">
//                   {taxonomyOptions.map((option) => (
//                     <button
//                       key={option.value}
//                       onClick={() => handleTaxonomyChange(option.value)}
//                       className={`w-full px-4 py-3 rounded-lg font-medium transition-all duration-200 flex items-center justify-center gap-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F7971E] ${
//                         selectedTaxonomy === option.value
//                           ? "bg-gradient-to-br from-[#FFD200] to-[#F7971E] text-black shadow-md transform scale-105"
//                           : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                       }`}
//                       aria-pressed={selectedTaxonomy === option.value}
//                     >
//                       <span className="text-sm font-semibold">{option.label}</span>
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               <FilterPanel
//                 filters={filters}
//                 setFilters={handleFilterChange}
//                 filterOptions={filterOptions}
//                 isLoading={filtersLoading}
//               />
//             </div>
//           </aside>

//           <main className="col-span-full lg:col-span-3" aria-label="Product listing">
//             {pinnedProducts.length > 0 && page === 1 && (
//               <section className="mb-5" aria-labelledby="bestselling-heading">
//                 <h2 
//                   id="bestselling-heading" 
//                   className="text-xl font-semibold mb-4 gradiantText"
//                 >
//                   Our Bestselling Products
//                 </h2>
//                 <div className="productListing grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 animate-fadeIn">
//                   {pinnedProducts.map((product) => (
//                     <ProductCard
//                       key={product.id}
//                       product={product}
//                       viewMode="grid"
//                       taxonomy={selectedTaxonomy}
//                       onClick={() =>
//                         navigate(`/product/${product.slug || "product"}/GS${product.id}`)
//                       }
//                     />
//                   ))}
//                 </div>
//                 <h2 className="text-xl font-semibold mt-4 grayText">
//                   Search Results
//                 </h2>
//               </section>
//             )}

//             {productsLoading ? (
//               <div
//                 className={`productListing grid gap-4 ${
//                   viewMode === "grid"
//                     ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
//                     : "grid-cols-1"
//                 }`}
//                 role="status"
//                 aria-label="Loading products"
//               >
//                 {[...Array(6)].map((_, index) => (
//                   <ProductCardSkeleton key={index} viewMode={viewMode} />
//                 ))}
//               </div>
//             ) : products.length > 0 ? (
//               <>
//                 <div
//                   className={`productListing grid gap-4 animate-fadeIn ${
//                     viewMode === "grid"
//                       ? "grid-cols-2 sm:grid-cols-2 lg:grid-cols-3"
//                       : "grid-cols-2"
//                   }`}
//                 >
//                   {products.map((product) => (
//                     <ProductCard
//                       key={product.id}
//                       product={product}
//                       viewMode={viewMode}
//                       taxonomy={selectedTaxonomy}
//                       isPinned={pinnedProductIds.includes(product.id)}
//                       onClick={() =>
//                         navigate(`/product/${product.slug || "product"}/GS${product.id}`)
//                       }
//                     />
//                   ))}
//                 </div>

//                 {totalPages > 1 && (
//                   <nav 
//                     className="mt-8"
//                     aria-label="Product pagination"
//                   >
//                     <Pagination
//                       currentPage={page}
//                       totalPages={totalPages}
//                       onPageChange={handlePageChange}
//                       isLoading={productsLoading}
//                     />
//                   </nav>
//                 )}
//               </>
//             ) : (
//               <div className="bg-white rounded-lg shadow-md p-12 text-center">
//                 <Package className="w-16 h-16 text-gray-400 mx-auto mb-4" aria-hidden="true" />
//                 <h3 className="text-lg font-medium text-gray-900 mb-2">
//                   No products found
//                 </h3>
//                 <p className="text-gray-500 mb-4">
//                   Try adjusting your filters or search terms
//                 </p>
//                 {Object.keys(filters).length > 0 && (
//                   <button
//                     onClick={() => handleFilterChange({})}
//                     className="px-4 py-2 bg-gradient-to-br from-[#FFD200] to-[#F7971E] text-white rounded-xl hover:from-[#F7971E] hover:to-[#FFD200] transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F7971E]"
//                   >
//                     Clear All Filters
//                   </button>
//                 )}
//               </div>
//             )}
//           </main>
//         </div>
//       </div>

//       <style jsx>{`
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//             transform: translateY(10px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         .animate-fadeIn {
//           animation: fadeIn 0.4s ease-out;
//         }

//         .gradiantText {
//           position: relative;
//           font-weight: 600;
//           background: linear-gradient(159.21deg, #eec712 11.19%, #ca7710 101.23%);
//           background-clip: text;
//           -webkit-background-clip: text;
//           color: transparent;
//           -webkit-text-fill-color: transparent;
//         }

//         .gradiantText::after {
//           content: "";
//           position: absolute;
//           top: 50%;
//           left: 65%;
//           transform: translate(-50%, -50%);
//           width: 70%;
//           height: 1.5px;
//           background: linear-gradient(159.21deg, #eec712 11.19%, #ca7710 101.23%);
//           transition: all 0.3s ease;
//         }

//         .grayText {
//           position: relative;
//           font-weight: 600;
//           background: #5b5b5b;
//           background-clip: text;
//           -webkit-background-clip: text;
//           color: transparent;
//           -webkit-text-fill-color: transparent;
//         }

//         .grayText::after {
//           content: "";
//           position: absolute;
//           top: 50%;
//           left: 60%;
//           transform: translate(-50%, -50%);
//           width: 80%;
//           height: 1.5px;
//           background: #5b5b5b;
//           transition: all 0.3s ease;
//         }

//         .productListing .recommended-product-card {
//           box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2) !important;
//         }

//         .productListing .recommended-product-card__title {
//           font-size: 1.1rem !important;
//         }

//         .productListing .recommended-product-card__btn {
//           font-size: 0.925rem !important;
//           padding: 0 !important;
//         }

//         .productListing .recommended-product-card__image-wrapper {
//           padding: 0 !important;
//           min-height: 200px;
//           max-height: 200px;
//         }

//         .productListing .recommended-product-card__image-wrapper img {
//           min-height: 200px;
//           max-height: 200px;
//           object-fit: cover;
//         }

//         .productListing .recommended-product-card__btn--primary {
//           padding: 0.5rem !important;
//         }

//         .productListing .recommended-product-card__btn--secondary {
//           background: linear-gradient(159.21deg, #eec712 11.19%, #ca7710 101.23%);
//           background-clip: text;
//           color: transparent;
//           -webkit-text-fill-color: transparent;
//           display: flex;
//           align-items: center;
//           gap: 0.3rem;
//         }

//         .productListing .recommended-product-card__btn--secondary::after {
//           content: "›";
//           font-size: 18px;
//           transition: transform 0.2s ease;
//         }

//         .productListing .recommended-product-card__badges {
//           bottom: 0.875rem !important;
//         }

//         .productListing .recommended-product-card__logo {
//           width: 80px !important;
//         }

//         .productListing .recommended-product-card__header {
//           align-items: flex-start !important;
//         }

//         @media (max-width: 1200px) {
//           .gradiantText::after {
//             left: 68%;
//             width: 62%;
//           }
//           .grayText::after {
//             left: 63%;
//             width: 75%;
//           }
//         }

//         @media (max-width: 992px) {
//           .gradiantText::after {
//             left: 70%;
//             width: 55%;
//           }
//           .grayText::after {
//             left: 65%;
//             width: 70%;
//           }
//         }

//         @media (max-width: 768px) {
//           .gradiantText,
//           .grayText {
//             font-size: 1rem;
//           }

//           .gradiantText::after,
//           .grayText::after {
//             width: 0%;
//           }
//         }

//         @media (max-width: 480px) {
//           .productListing .new-product-card {
//             min-height: 100% !important;
//           }
//         }

//         @media (min-width: 1600px) {
//           .gradiantText::after {
//             width: 70%;
//           }
//           .grayText::after {
//             width: 80%;
//           }
//         }
//       `}</style>
//     </div>
//   );
// }


/**
 * ProductListingPage Component - Production Optimized Version
 * 
 * Key Improvements:
 * - Reduced re-renders with useMemo and useCallback
 * - Simplified URL synchronization logic
 * - Better error boundaries and loading states
 * - Improved accessibility (ARIA labels, keyboard navigation)
 * - Request cancellation for API calls
 * - Cleaner state management
 */

import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import {
  Package,
  Home,
  ChevronRight,
  Grid,
  List,
  Filter,
  X,
  ChevronDown,
} from "lucide-react";
import FilterPanel from "../components/FiltersPanel";
import ProductCard, { ProductCardSkeleton } from "../components/NewProductCard";
import Pagination from "../components/Pagination";
import { fetchProducts, fetchFilterOptions } from "../services/api";
import useDebounce from "../hooks/useDebounce";
import { API_CONFIG, SORT_OPTIONS, debugLog } from "../constants/config";

// ✅ Constants extracted for reusability
const RESERVED_PARAMS = ["taxonomy", "term", "termName", "label", "page", "sort", "order"];
const DEFAULT_TAXONOMY = "equipment-buy";
const PINNED_LIMIT = 3;

// ✅ Utility function - moved outside component for performance
const parseFiltersFromParams = (params) => {
  const filters = {};
  params.forEach((value, key) => {
    if (!RESERVED_PARAMS.includes(key) && value) {
      filters[key] = value.includes(",") 
        ? value.split(",").map(v => v.trim()).filter(Boolean)
        : value;
    }
  });
  return filters;
};

// ✅ Product sorting utility - memoized outside component
const sortProductsWithPinnedItems = (products, { category, tag, limit = PINNED_LIMIT }) => {
  const pinned = [];
  const regular = [];

  products.forEach((product) => {
    const productCategory =
      product.attributes?.pa_category ||
      product.pa_category ||
      product.category ||
      "";
    const productTags = Array.isArray(product.tags)
      ? product.tags.map((t) => (typeof t === "object" ? t.slug || t.name : t))
      : [];

    const matchesCategory =
      productCategory?.toString().toLowerCase() === category.toLowerCase();
    const matchesTag =
      productTags.includes(tag) || productTags.includes(tag.toLowerCase());

    if (matchesCategory && matchesTag && pinned.length < limit) {
      pinned.push(product);
    } else {
      regular.push(product);
    }
  });

  return [...pinned, ...regular];
};

export default function ProductListingPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // ✅ Refs for managing side effects
  const isInternalUpdate = useRef(false);
  const prevCategoryRef = useRef(null);
  const abortControllerRef = useRef(null);

  // ✅ Core state - using lazy initialization
  const [selectedTaxonomy, setSelectedTaxonomy] = useState(
    () => searchParams.get("taxonomy") || DEFAULT_TAXONOMY
  );
  
  const [filters, setFilters] = useState(() => {
    const urlTerm = searchParams.get("term");
    return urlTerm ? { product_cat: [urlTerm] } : parseFiltersFromParams(searchParams);
  });

  const [page, setPage] = useState(
    () => Math.max(1, parseInt(searchParams.get("page")) || 1)
  );

  const [sort, setSort] = useState(() => ({
    orderby: searchParams.get("sort") || "rand",
    order: searchParams.get("order") || "desc"
  }));

  const [viewMode, setViewMode] = useState("grid");
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  // ✅ Data state
  const [products, setProducts] = useState([]);
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [filterOptions, setFilterOptions] = useState(null);
  const [pinnedProducts, setPinnedProducts] = useState([]);
  const [pinnedProductIds, setPinnedProductIds] = useState([]);

  // ✅ Loading & error state
  const [productsLoading, setProductsLoading] = useState(false);
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [error, setError] = useState(null);

  // ✅ Debounced search with minimum character validation
  const searchValue = filters.search || "";
  const debouncedSearch = useDebounce(
    searchValue.length >= 3 ? searchValue : "",
    500
  );

  // ✅ Memoized active filter count (excludes search)
  const activeFilterCount = useMemo(() => {
    return Object.keys(filters).filter((key) => {
      if (key === "search") return false;
      const value = filters[key];
      return value !== undefined &&
             value !== "" &&
             (Array.isArray(value) ? value.length > 0 : true);
    }).length;
  }, [filters]);

  // ✅ Memoized breadcrumb generation
  const breadcrumb = useMemo(() => {
    const parts = [
      { label: <Home className="w-4 h-4" />, path: "/" },
      { label: "Inventory", path: "/products" },
    ];

    const label = selectedTaxonomy === "equipment-buy" 
      ? "For Sale" 
      : "For Rent";
    
    parts.push({
      label,
      path: `/products?taxonomy=${selectedTaxonomy}`,
    });

    return parts;
  }, [selectedTaxonomy]);

  // ✅ Handle body scroll lock for mobile filters
  useEffect(() => {
    if (!showMobileFilters) {
      document.body.style.overflow = "unset";
      return;
    }

    document.body.style.overflow = "hidden";

    const handleEscape = (e) => {
      if (e.key === "Escape") setShowMobileFilters(false);
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [showMobileFilters]);

  // ✅ Enhanced URL synchronization with category change detection
  useEffect(() => {
    if (isInternalUpdate.current) {
      isInternalUpdate.current = false;
      return;
    }

    const taxonomy = searchParams.get("taxonomy") || DEFAULT_TAXONOMY;
    const urlTerm = searchParams.get("term") || "";
    const pageFromUrl = Math.max(1, parseInt(searchParams.get("page")) || 1);
    const sortFromUrl = searchParams.get("sort") || "rand";
    const orderFromUrl = searchParams.get("order") || "desc";

    // ✅ Detect category changes
    const currentCategoryId = `${taxonomy}|${urlTerm}`;
    const categoryChanged = prevCategoryRef.current !== null && 
                           prevCategoryRef.current !== currentCategoryId;

    if (categoryChanged) {
      debugLog("🆕 Category changed - resetting filters");
      
      const freshFilters = urlTerm ? { product_cat: [urlTerm] } : {};
      setFilters(freshFilters);
      setSelectedTaxonomy(taxonomy);
      setPage(1);
      setError(null);
      prevCategoryRef.current = currentCategoryId;
      
      return;
    }

    // ✅ Initialize category tracking
    if (prevCategoryRef.current === null) {
      prevCategoryRef.current = currentCategoryId;
    }

    // ✅ Sync all filters when category hasn't changed
    const newFilters = parseFiltersFromParams(searchParams);
    
    // Ensure URL category is in filters
    if (urlTerm) {
      if (!newFilters.product_cat) {
        newFilters.product_cat = [urlTerm];
      } else if (!Array.isArray(newFilters.product_cat)) {
        newFilters.product_cat = [newFilters.product_cat];
      } else if (!newFilters.product_cat.includes(urlTerm)) {
        newFilters.product_cat = [...newFilters.product_cat, urlTerm];
      }
    }

    // ✅ Batch state updates to prevent multiple re-renders
    const updates = [];
    
    if (selectedTaxonomy !== taxonomy) updates.push(() => setSelectedTaxonomy(taxonomy));
    if (JSON.stringify(filters) !== JSON.stringify(newFilters)) updates.push(() => setFilters(newFilters));
    if (sort.orderby !== sortFromUrl || sort.order !== orderFromUrl) {
      updates.push(() => setSort({ orderby: sortFromUrl, order: orderFromUrl }));
    }
    if (page !== pageFromUrl) updates.push(() => setPage(pageFromUrl));
    if (error) updates.push(() => setError(null));

    // Execute all updates
    updates.forEach(update => update());

  }, [searchParams]); // ✅ Only depend on searchParams

  // ✅ Taxonomy options configuration
  const taxonomyOptions = useMemo(() => [
    { value: "equipment-buy", label: "Buy", icon: "", color: "" },
    { value: "equipment-rent", label: "Rent", icon: "", color: "" },
  ], []);

  // ✅ Optimized taxonomy change handler
  const handleTaxonomyChange = useCallback((newTaxonomy) => {
    isInternalUpdate.current = true;
    setSelectedTaxonomy(newTaxonomy);
    setFilters({});
    setShowMobileFilters(false);

    const params = new URLSearchParams();
    params.set("taxonomy", newTaxonomy);
    setSearchParams(params);
  }, [setSearchParams]);

  // ✅ Optimized filter change handler
  const handleFilterChange = useCallback((newFilters) => {
    isInternalUpdate.current = true;
    setFilters(newFilters);

    const params = new URLSearchParams(searchParams);
    
    // Remove old filter params
    const keysToRemove = [];
    params.forEach((_, key) => {
      if (!RESERVED_PARAMS.includes(key)) keysToRemove.push(key);
    });
    keysToRemove.forEach((key) => params.delete(key));

    // Add new filter params
    Object.entries(newFilters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        if (Array.isArray(value) && value.length > 0) {
          params.set(key, value.join(","));
        } else if (!Array.isArray(value)) {
          params.set(key, String(value));
        }
      }
    });

    // Reset page to 1 when filters change
    if (page !== 1) {
      setPage(1);
      params.set("page", "1");
    } else {
      params.delete("page");
    }

    setSearchParams(params, { replace: true });
    setShowMobileFilters(false);
  }, [searchParams, page, setSearchParams]);

  // ✅ Load filter options with abort controller
  useEffect(() => {
    const controller = new AbortController();

    const loadOptions = async () => {
      setFiltersLoading(true);

      try {
        const response = await fetchFilterOptions(selectedTaxonomy, {
          signal: controller.signal
        });
        setFilterOptions(response);
      } catch (err) {
        if (err.name !== 'AbortError') {
          setError("Failed loading filters: " + err.message);
          debugLog("❌ Filter options error:", err);
        }
      } finally {
        setFiltersLoading(false);
      }
    };

    loadOptions();

    return () => controller.abort();
  }, [selectedTaxonomy, JSON.stringify(filters), debouncedSearch]);

  // ✅ Load pinned products (bestselling) - optimized
  // useEffect(() => {
  //   if (page !== 1) {
  //     setPinnedProducts([]);
  //     return;
  //   }

  //   const controller = new AbortController();

  //   const loadPinnedProducts = async () => {
  //     try {
  //       const res = await fetch(
  //         "https://goldensparrowuae.com/wordpress/wp-json/custom/v1/products?pa_bestselling=yes&per_page=20",
  //         { signal: controller.signal }
  //       );
        
  //       if (!res.ok) throw new Error('Failed to fetch pinned products');
        
  //       const data = await res.json();
  //       if (!data?.products) return;

  //       const selectedTermName = searchParams.get("termName") || "";
        
  //       // Parent term fallback map
  //       const parentTermMap = {
  //         "Diesel Forklifts": "Forklifts",
  //         "Electric Forklifts": "Forklifts",
  //       };

  //       const effectiveTerm = parentTermMap[selectedTermName] || selectedTermName;

  //       const filteredPinned = data.products.filter((product) => {
  //         const categories = product.attributes?.pa_categories || [];
  //         return categories.some(
  //           (cat) => cat.toLowerCase().trim() === effectiveTerm.toLowerCase().trim()
  //         );
  //       });

  //       setPinnedProducts(filteredPinned);
  //     } catch (err) {
  //       if (err.name !== 'AbortError') {
  //         console.error("❌ Failed to load pinned products:", err);
  //         setPinnedProducts([]);
  //       }
  //     }
  //   };

  //   loadPinnedProducts();

  //   return () => controller.abort();
  // }, [searchParams, page]);

  // ✅ Load pinned products (bestselling) - with filter AND termName validation
useEffect(() => {
  // Don't show pinned products if not on page 1
  if (page !== 1) {
    setPinnedProducts([]);
    return;
  }

  const selectedTermName = searchParams.get("termName") || "";
  
  // Parent term fallback map
  const parentTermMap = {
    "Diesel Forklifts": "Forklifts",
    "Electric Forklifts": "Forklifts",
  };

  const effectiveTerm = parentTermMap[selectedTermName] || selectedTermName;

  // ✅ NEW: Check if Forklifts category is selected in filters
  const productCatFilter = filters.product_cat || [];
  const hasForkliftsInFilters = Array.isArray(productCatFilter) 
    ? productCatFilter.some(cat => {
        const normalizedCat = cat.toLowerCase().trim();
        return normalizedCat === 'forklifts' || 
               normalizedCat === 'diesel forklifts' || 
               normalizedCat === 'electric forklifts';
      })
    : false;

  // ✅ NEW: Both conditions must be true
  const shouldShowPinned = effectiveTerm.toLowerCase() === 'forklifts' && hasForkliftsInFilters;

  if (!shouldShowPinned) {
    setPinnedProducts([]);
    return;
  }

  const controller = new AbortController();

  const loadPinnedProducts = async () => {
    try {
      const res = await fetch(
        "https://goldensparrowuae.com/wordpress/wp-json/custom/v1/products?pa_bestselling=yes&per_page=20",
        { signal: controller.signal }
      );
      
      if (!res.ok) throw new Error('Failed to fetch pinned products');
      
      const data = await res.json();
      if (!data?.products) return;

      const filteredPinned = data.products.filter((product) => {
        const categories = product.attributes?.pa_categories || [];
        return categories.some(
          (cat) => cat.toLowerCase().trim() === effectiveTerm.toLowerCase().trim()
        );
      });

      setPinnedProducts(filteredPinned);
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error("❌ Failed to load pinned products:", err);
        setPinnedProducts([]);
      }
    }
  };

  loadPinnedProducts();

  return () => controller.abort();
}, [searchParams, page, filters]);

  // ✅ Load products with improved abort handling and error recovery
  useEffect(() => {
    // Cancel previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    const loadProducts = async () => {
      setProductsLoading(true);
      setError(null);

      try {
        const urlTerm = searchParams.get("term") || "";
        const termName = searchParams.get("termName") || "";

        // Build API filters
        const apiFilters = { ...filters };
        const hasFilterCategory = apiFilters.product_cat?.length > 0;

        if (hasFilterCategory) {
          delete apiFilters.pa_categories;
        } else if (urlTerm) {
          apiFilters.pa_categories = urlTerm;
        }

        if (debouncedSearch) {
          apiFilters.search = debouncedSearch;
        } else {
          delete apiFilters.search;
        }

        const baseParams = {
          taxonomy: selectedTaxonomy,
          page,
          per_page: API_CONFIG.DEFAULT_PER_PAGE,
          orderby: sort.orderby,
          order: sort.order,
          ...apiFilters,
        };

        delete baseParams.term;

        // Initial fetch
        const firstResponse = await fetchProducts(baseParams, {
          signal: controller.signal
        });
        
        let sortedProducts = firstResponse.products || [];

        // Apply pinning logic for Forklifts
        const shouldPin = termName.toLowerCase() === "forklifts";
        let forkliftPinnedIds = [];

        if (shouldPin && page === 1) {
          sortedProducts = sortProductsWithPinnedItems(sortedProducts, {
            category: "Forklifts",
            tag: "Best Selling",
            limit: PINNED_LIMIT,
          });

          forkliftPinnedIds = sortedProducts.slice(0, PINNED_LIMIT).map((p) => p.id);
        }

        // Top-up logic to fill page
        const collected = [...sortedProducts];
        const totalPagesFromApi = firstResponse.totalPages ?? 1;

        if (collected.length < API_CONFIG.DEFAULT_PER_PAGE && page < totalPagesFromApi) {
          let nextPage = page + 1;
          let attempts = 0;

          while (
            collected.length < API_CONFIG.DEFAULT_PER_PAGE &&
            nextPage <= totalPagesFromApi &&
            attempts < 5
          ) {
            const topUpParams = { ...baseParams, page: nextPage };
            const res = await fetchProducts(topUpParams, {
              signal: controller.signal
            });
            
            const nextProds = res.products || [];

            nextProds.forEach((p) => {
              if (!collected.find((c) => c.id === p.id)) {
                collected.push(p);
              }
            });

            nextPage++;
            attempts++;
          }
        }

        setProducts(collected);
        setPinnedProductIds(forkliftPinnedIds);

        const visibleTotal = firstResponse.total || collected.length;
        setTotalProducts(visibleTotal);
        setTotalPages(Math.max(1, Math.ceil(visibleTotal / API_CONFIG.DEFAULT_PER_PAGE)));

      } catch (err) {
        if (err.name !== 'AbortError') {
          debugLog("❌ Failed loading products:", err);
          setError(`Failed loading products: ${err.message}`);
          setProducts([]);
        }
      } finally {
        if (!controller.signal.aborted) {
          setProductsLoading(false);
        }
      }
    };

    loadProducts();

    return () => {
      controller.abort();
      abortControllerRef.current = null;
    };
  }, [
    selectedTaxonomy,
    page,
    sort.orderby,
    sort.order,
    debouncedSearch,
    JSON.stringify(filters),
    searchParams.toString(),
    pinnedProducts.length,
  ]);

  // ✅ Optimized sort change handler
  const handleSortChange = useCallback((value) => {
    isInternalUpdate.current = true;

    const [orderby, order = "desc"] = value.split("-");
    setSort({ orderby, order });

    const params = new URLSearchParams(searchParams);
    params.set("sort", orderby);
    params.set("order", order);

    setSearchParams(params, { replace: false });
  }, [searchParams, setSearchParams]);

  // ✅ Optimized page change handler
  const handlePageChange = useCallback((newPage) => {
    isInternalUpdate.current = true;
    setPage(newPage);

    const params = new URLSearchParams(searchParams);
    if (newPage > 1) {
      params.set("page", newPage.toString());
    } else {
      params.delete("page");
    }

    setSearchParams(params, { replace: false });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [searchParams, setSearchParams]);

  const termName = searchParams.get("termName") || "";
  const label = searchParams.get("label") || "";

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Breadcrumb */}
        <nav
          className="flex items-center text-sm text-gray-600 mb-6"
          aria-label="Breadcrumb"
        >
          {breadcrumb.map((item, index) => (
            <React.Fragment key={index}>
              {index > 0 && <ChevronRight className="w-4 h-4 mx-2" aria-hidden="true" />}
              {item.path ? (
                <Link 
                  to={item.path} 
                  className="hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black rounded"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-gray-900 font-medium">{item.label}</span>
              )}
            </React.Fragment>
          ))}
        </nav>

        {/* Page Header */}
        <div className="mb-8">
          <div className="bg-white rounded-lg shadow-md p-3 sm:p-4 mt-4">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4">
              <div className="flex flex-row items-center gap-16">
                <h1 className="text-xl sm:text-3xl font-medium text-gray-900 mb-2">
                  {termName ||
                    label ||
                    (selectedTaxonomy === "equipment-buy" ? "For Sale" : "For Rent")}
                </h1>
                
                {/* Results Count */}
                <div className="flex items-center" role="status" aria-live="polite">
                  <span className="text-[#5B5B5B]">
                    {productsLoading ? (
                      <span className="flex items-center gap-2">
                        <div 
                          className="w-5 h-5 border-3 border-gray-300 border-t-[#F7971E] rounded-full animate-spin"
                          role="progressbar"
                          aria-label="Loading products"
                        />
                        <span className="text-gray-700 font-medium">
                          Loading products...
                        </span>
                      </span>
                    ) : (
                      <span>
                        <span className="font-semibold text-[#5B5B5B]">
                          {totalProducts}
                        </span>{" "}
                        products found
                      </span>
                    )}
                  </span>
                </div>
              </div>

              {/* Controls */}
              <div className="flex items-center gap-3">
                {/* Mobile Filter Button */}
                <button
                  onClick={() => setShowMobileFilters(true)}
                  className="lg:hidden flex items-center gap-2 px-3 sm:px-4 py-2 bg-gradient-to-br from-[#FFD200] to-[#F7971E] text-white rounded-md hover:from-[#F7971E] hover:to-[#FFD200] transition-colors relative focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F7971E]"
                  aria-label={`Open filters${activeFilterCount > 0 ? `, ${activeFilterCount} active` : ''}`}
                >
                  <Filter className="w-4 h-4" aria-hidden="true" />
                  <span className="text-xs sm:text-sm font-medium">Filters</span>
                  {activeFilterCount > 0 && (
                    <span 
                      className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center"
                      aria-label={`${activeFilterCount} filters active`}
                    >
                      {activeFilterCount > 9 ? "9+" : activeFilterCount}
                    </span>
                  )}
                </button>

                {/* Sort Dropdown */}
                <div className="flex items-center gap-2">
                  <label 
                    htmlFor="sort-select" 
                    className="text-sm text-gray-600 hidden sm:inline"
                  >
                    Sort by:
                  </label>
                  <div className="relative">
                    <select
                      id="sort-select"
                      value={`${sort.orderby}-${sort.order}`}
                      onChange={(e) => handleSortChange(e.target.value)}
                      className="appearance-none pr-10 px-6 text-xs sm:text-base py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                      aria-label="Sort products by"
                    >
                      {SORT_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-black">
                      <ChevronDown className="w-4 h-4 sm:w-5 sm:h-5" aria-hidden="true" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Error Message */}
        {error && (
          <div
            className="mb-6 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg"
            role="alert"
            aria-live="assertive"
          >
            <strong className="font-semibold">Error: </strong>
            <span>{error}</span>
          </div>
        )}

        {/* Mobile Filter Overlay */}
        {showMobileFilters && (
          <div 
            className="fixed inset-0 z-50 lg:hidden"
            role="dialog"
            aria-modal="true"
            aria-labelledby="mobile-filters-title"
          >
            <div
              className="absolute inset-0 bg-black bg-opacity-50 transition-opacity duration-300 ease-in-out"
              onClick={() => setShowMobileFilters(false)}
              aria-label="Close filters"
            />

            <div className="absolute inset-y-0 left-0 w-full max-w-sm bg-white shadow-xl overflow-y-auto transform transition-transform duration-300 ease-in-out translate-x-0">
              <div className="p-4">
                <div className="flex items-center justify-between mb-4">
                  <h2 id="mobile-filters-title" className="text-lg font-semibold">
                    Filter Products
                  </h2>
                  <button
                    onClick={() => setShowMobileFilters(false)}
                    className="text-gray-900 font-semibold text-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black rounded p-1"
                    aria-label="Close filters"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>

                <div className="bg-gray-50 rounded-lg p-3 mb-4">
                  <p className="font-semibold text-sm my-2 text-gray-700">
                    View Products For
                  </p>
                  <div className="flex flex-row gap-2">
                    {taxonomyOptions.map((option) => (
                      <button
                        key={option.value}
                        onClick={() => handleTaxonomyChange(option.value)}
                        className={`w-full px-4 py-3 rounded-lg font-medium transition-all duration-200 flex items-center justify-center gap-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F7971E] ${
                          selectedTaxonomy === option.value
                            ? "bg-gradient-to-br from-[#FFD200] to-[#F7971E] text-black shadow-md"
                            : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
                        }`}
                        aria-pressed={selectedTaxonomy === option.value}
                      >
                        <span className="text-sm font-semibold">{option.label}</span>
                      </button>
                    ))}
                  </div>
                </div>

                <FilterPanel
                  filters={filters}
                  setFilters={handleFilterChange}
                  filterOptions={filterOptions}
                  isLoading={filtersLoading}
                />
              </div>
            </div>
          </div>
        )}

        {/* Main Content Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Filters Sidebar - Desktop */}
          <aside className="hidden lg:block lg:col-span-1" aria-label="Product filters">
            <div className="sticky top-20">
              <div className="bg-white rounded-lg shadow-md p-4 mb-4">
                <div className="flex gap-2">
                  {taxonomyOptions.map((option) => (
                    <button
                      key={option.value}
                      onClick={() => handleTaxonomyChange(option.value)}
                      className={`w-full px-4 py-3 rounded-lg font-medium transition-all duration-200 flex items-center justify-center gap-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F7971E] ${
                        selectedTaxonomy === option.value
                          ? "bg-gradient-to-br from-[#FFD200] to-[#F7971E] text-black shadow-md transform scale-105"
                          : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                      }`}
                      aria-pressed={selectedTaxonomy === option.value}
                    >
                      <span className="text-sm font-semibold">{option.label}</span>
                    </button>
                  ))}
                </div>
              </div>

              <FilterPanel
                filters={filters}
                setFilters={handleFilterChange}
                filterOptions={filterOptions}
                isLoading={filtersLoading}
              />
            </div>
          </aside>

          {/* Products Grid */}
          <main className="col-span-full lg:col-span-3" aria-label="Product listing">
            {/* Bestselling Products Section */}
            {pinnedProducts.length > 0 && page === 1 && (
              <section className="mb-5" aria-labelledby="bestselling-heading">
                <h2 
                  id="bestselling-heading" 
                  className="text-xl font-semibold mb-4 gradiantText"
                >
                  Our Bestselling Products
                </h2>
                <div className="productListing grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 animate-fadeIn">
                  {pinnedProducts.map((product) => (
                    <ProductCard
                      key={product.id}
                      product={product}
                      viewMode="grid"
                      taxonomy={selectedTaxonomy}
                      onClick={() =>
                        navigate(`/product/${product.slug || "product"}/GS${product.id}`)
                      }
                    />
                  ))}
                </div>
                <h2 className="text-xl font-semibold mt-4 grayText">
                  Search Results
                </h2>
              </section>
            )}

            {/* Loading State */}
            {productsLoading ? (
              <div
                className={`productListing grid gap-4 ${
                  viewMode === "grid"
                    ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
                    : "grid-cols-1"
                }`}
                role="status"
                aria-label="Loading products"
              >
                {[...Array(6)].map((_, index) => (
                  <ProductCardSkeleton key={index} viewMode={viewMode} />
                ))}
              </div>
            ) : products.length > 0 ? (
              <>
                {/* Products Grid */}
                <div
                  className={`productListing grid gap-4 animate-fadeIn ${
                    viewMode === "grid"
                      ? "grid-cols-2 sm:grid-cols-2 lg:grid-cols-3"
                      : "grid-cols-2"
                  }`}
                >
                  {products.map((product) => (
                    <ProductCard
                      key={product.id}
                      product={product}
                      viewMode={viewMode}
                      taxonomy={selectedTaxonomy}
                      isPinned={pinnedProductIds.includes(product.id)}
                      onClick={() =>
                        navigate(`/product/${product.slug || "product"}/GS${product.id}`)
                      }
                    />
                  ))}
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <nav 
                    className="mt-8"
                    aria-label="Product pagination"
                  >
                    <Pagination
                      currentPage={page}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                      isLoading={productsLoading}
                    />
                  </nav>
                )}
              </>
            ) : (
              /* No Products Found */
              <div className="bg-white rounded-lg shadow-md p-12 text-center">
                <Package className="w-16 h-16 text-gray-400 mx-auto mb-4" aria-hidden="true" />
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  No products found
                </h3>
                <p className="text-gray-500 mb-4">
                  Try adjusting your filters or search terms
                </p>
                {Object.keys(filters).length > 0 && (
                  <button
                    onClick={() => handleFilterChange({})}
                    className="px-4 py-2 bg-gradient-to-br from-[#FFD200] to-[#F7971E] text-white rounded-xl hover:from-[#F7971E] hover:to-[#FFD200] transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F7971E]"
                  >
                    Clear All Filters
                  </button>
                )}
              </div>
            )}
          </main>
        </div>
      </div>

      {/* Scoped Styles */}
      <style jsx>{`
        /* Fade-in animation */
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.4s ease-out;
        }

        /* Gradient Text Style */
        .gradiantText {
          position: relative;
          font-weight: 600;
          background: linear-gradient(159.21deg, #eec712 11.19%, #ca7710 101.23%);
          background-clip: text;
          -webkit-background-clip: text;
          color: transparent;
          -webkit-text-fill-color: transparent;
        }

        .gradiantText::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 65%;
          transform: translate(-50%, -50%);
          width: 70%;
          height: 1.5px;
          background: linear-gradient(159.21deg, #eec712 11.19%, #ca7710 101.23%);
          transition: all 0.3s ease;
        }

        /* Gray Text Style */
        .grayText {
          position: relative;
          font-weight: 600;
          background: #5b5b5b;
          background-clip: text;
          -webkit-background-clip: text;
          color: transparent;
          -webkit-text-fill-color: transparent;
        }

        .grayText::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 60%;
          transform: translate(-50%, -50%);
          width: 80%;
          height: 1.5px;
          background: #5b5b5b;
          transition: all 0.3s ease;
        }

        /* Product Card Customizations */
        .productListing .recommended-product-card {
          box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2) !important;
        }

        .productListing .recommended-product-card__title {
          font-size: 1.1rem !important;
        }

        .productListing .recommended-product-card__btn {
          font-size: 0.925rem !important;
          padding: 0 !important;
        }

        .productListing .recommended-product-card__image-wrapper {
          padding: 0 !important;
          min-height: 200px;
          max-height: 200px;
        }

        .productListing .recommended-product-card__image-wrapper img {
          min-height: 200px;
          max-height: 200px;
          object-fit: cover;
        }

        .productListing .recommended-product-card__btn--primary {
          padding: 0.5rem !important;
        }

        .productListing .recommended-product-card__btn--secondary {
          background: linear-gradient(159.21deg, #eec712 11.19%, #ca7710 101.23%);
          background-clip: text;
          color: transparent;
          -webkit-text-fill-color: transparent;
          display: flex;
          align-items: center;
          gap: 0.3rem;
        }

        .productListing .recommended-product-card__btn--secondary::after {
          content: "›";
          font-size: 18px;
          transition: transform 0.2s ease;
        }

        .productListing .recommended-product-card__badges {
          bottom: 0.875rem !important;
        }

        .productListing .recommended-product-card__logo {
          width: 80px !important;
        }

        .productListing .recommended-product-card__header {
          align-items: flex-start !important;
        }

        /* Responsive Breakpoints */
        @media (max-width: 1200px) {
          .gradiantText::after {
            left: 68%;
            width: 62%;
          }
          .grayText::after {
            left: 63%;
            width: 75%;
          }
        }

        @media (max-width: 992px) {
          .gradiantText::after {
            left: 70%;
            width: 55%;
          }
          .grayText::after {
            left: 65%;
            width: 70%;
          }
        }

        @media (max-width: 768px) {
          .gradiantText,
          .grayText {
            font-size: 1rem;
          }

          .gradiantText::after,
          .grayText::after {
            width: 0%;
          }
        }

        @media (max-width: 480px) {
          .productListing .new-product-card {
            min-height: 100% !important;
          }
        }

        @media (min-width: 1600px) {
          .gradiantText::after {
            width: 70%;
          }
          .grayText::after {
            width: 80%;
          }
        }
      `}</style>
    </div>
  );
}
